import { render, staticRenderFns } from "./SwiperCom.vue?vue&type=template&id=572b4070&scoped=true&"
import script from "./SwiperCom.vue?vue&type=script&lang=js&"
export * from "./SwiperCom.vue?vue&type=script&lang=js&"
import style0 from "./SwiperCom.vue?vue&type=style&index=0&id=572b4070&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572b4070",
  null
  
)

export default component.exports